/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".status-content[_ngcontent-%COMP%] {\n  padding: 15px !important;\n}\n\n.green[_ngcontent-%COMP%] {\n  color: green;\n}\n\n.red[_ngcontent-%COMP%] {\n  color: red;\n}\n\n.outagelink[_ngcontent-%COMP%] {\n  color: #3F8F8B !important;\n  text-decoration: none !important;\n  font-weight: 600 !important;\n  font-size: 18px;\n  padding-top: 10px;\n  padding-left: 10px;\n}\n\n.top-container[_ngcontent-%COMP%] {\n  min-height: 305px;\n  overflow: auto;\n}\n\n.list-group[_ngcontent-%COMP%]{\n  margin-bottom: 5px !important;\n}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/status-container/status-container.component.css.shim.ngstyle.js.pre-build-optimizer.js